<template>
  <div
    :class="{'-small': size === 'small'}"
    class="button-outer"
    @click="$emit('click')"
  >
    <div class="button-inner">
      <slot />
    </div>
  </div>
</template>
<script>
export default {
  props: {
    size: {
      type: String,
      default: null,
    }
  }
}
</script>
<style lang="scss" scoped>
.button-outer {
  position: relative;
  padding: 0 11%;
  height: 100%;
  background-image:
    url(#{$img-path}button-blue/bg_btn-left.png),
    url(#{$img-path}button-blue/bg_btn-right.png);
  background-position: 0 50%, 100% 50%;
  background-repeat: no-repeat, no-repeat;
  background-size: auto 100%, auto 100%;
  @include tap-event();
  &.-small {
    padding: 0 10%;
  }
}
.button-inner {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  background-image: url(#{$img-path}button-blue/bg_btn-center.png);
  background-repeat: repeat-x;
  background-position: 50% 0;
  background-size: auto 100%;
}
</style>
